/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import { jsx } from '@emotion/core';
import { FxJourneyCompletionPage, FxMultiButtons } from 'axp-fx-common'; // eslint-disable-line no-unused-vars
import { routes } from '../../../constants/paths';
import labels from '../../../constants/labels';

const RegistrationSuccessPage = () => {
  const onLoginBtnClick = () => {
    window.location.replace(routes.home);
  };
  const actions = (
    <FxMultiButtons
      primaryButtonLabel={labels.LOGIN}
      onPrimaryButtonClick={onLoginBtnClick}
      justifyButtons="center"
    />
  );

  return (
    <div
      className="flex flex-column flex-justify-center"
      css={{ height: '80%' }}
    >
      <FxJourneyCompletionPage
        status="success"
        heading="Congratulations! You’re all set."
        details="Your FileXpress site registration has been completed."
        actions={actions}
      />
    </div>
  );
};

export default RegistrationSuccessPage;
